const PRE = 'OKREPORTFORM';


export const SET_JSON_GERAR = PRE + 'SET_JSON_GERAR';


export const SALVAR = PRE + 'SALVAR';
export const LISTAR = PRE + 'LISTAR';

export const LISTAR_RELATORIOS_USER = PRE + 'LISTAR_RELATORIOS_USER';
export const LISTAR_RELATORIOS_PUBLICO = PRE + 'LISTAR_RELATORIOS_PUBLICO';


// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/actionTypes.js